import React from 'react';

const FlagMl = props => (
  <svg viewBox="0 0 450 300" {...props}>
    <path fill="#CE1126" d="M0 0h450v300H0z" />
    <path fill="#FCD116" d="M0 0h300v300H0z" />
    <path fill="#14B53A" d="M0 0h150v300H0z" />
  </svg>
);

export default FlagMl;
